function Modal(params) {
	//console.log(params);
	const title = params.title;
	const body = params.body;
	const actionCallback = params.actionCallback;
	const actionText = params.actionText;
	const id = params.id;

	return (
		<>
			<div
				className="modal fade"
				id={id}
				tabIndex="-1"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								{title}
							</h5>
							<button
								type="button"
								className="btn-close"
								data-bs-dismiss="modal"
								aria-label="Close"
							></button>
						</div>
						<div className="modal-body">{body}</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-secondary"
								data-bs-dismiss="modal"
							>
								Close
							</button>

							{actionCallback && (
								<button
									onClick={actionCallback}
									type="button"
									className="btn btn-primary"
									data-bs-dismiss="modal"
								>
									{actionText}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Modal;
